export default __webpack_public_path__ + "static/media/imec_logo_rgb.48778ff4.svg";